import React, {PureComponent} from 'react';
import i18n from '../locales/i18n';
import oakley from '../assets/oakley-logo.svg';

import './MainMenu.css';

const LANGS = {
    en: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    pr: 'Português',
    kr: '한국어',
    jp: '日本語',
    sc: '简体中文翻译',
    tc: '繁體中文翻譯',
};
let currentLang = localStorage.getItem('i18n-lang');

export default class MainMenu extends PureComponent {
    state = {status: false};

    componentWillMount() {
        currentLang = localStorage.getItem('i18n-lang');
    }

    handleMenu() {
        this.setState({
            status: !this.state.status,
        });
    }

    changeLang(lang) {
        i18n.changeLanguage(lang);
        currentLang = localStorage.getItem('i18n-lang');

        this.setState({
            status: false,
        });
    }

    render() {
        const listItems = Object.keys(LANGS).map(itemKey => (
            <li
                key={itemKey}
                className={
                    currentLang === itemKey
                        ? 'MainMenu-item MainMenu-item--active'
                        : 'MainMenu-item'
                }>
                <button onClick={() => this.changeLang(itemKey)}>
                    {LANGS[itemKey]}
                </button>
            </li>
        ));

        return (
            <div className={this.state.status ? 'MainMenu active' : 'MainMenu'}>
                <a className="MainMenu-btn" onClick={() => this.handleMenu()}>
                    <span className="hidden">Menu</span>
                    <div className="MainMenu-line" />
                    <div className="MainMenu-line" />
                    <div className="MainMenu-line" />
                </a>
                <div className="MainMenu-content">
                    <img className="MainMenu-logo" src={oakley} alt="" />
                    <ul>{listItems}</ul>
                </div>
                <div
                    className="MainMenu-overlay"
                    onClick={() => this.handleMenu()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/atoms/MainMenu.js